import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LoginNewCommon from '../../components/login/LoginNewCommon';
import { saveUserInfo } from '../../store/actions';
import { setStore } from '../../config/storage';
import { openInWebview, isAndroid } from '../../config/env';
import {Helmet} from "react-helmet";
class LoginNew extends Component {
  nextFunc = (value) => {
    let { saveUserInfo } = this.props;
    setStore('token', value.token); //token存到localstorage
    saveUserInfo(value); //存到redux
    this.props.history.replace('/');
  }
  // 安卓机app内展示关闭按钮
  componentWillMount() {
    // 打开后调用安卓的方法
    var isWebView = openInWebview();
    if (isWebView && isAndroid) {
      if (window.android && window.android.visibilityFin) {
        window.android.visibilityFin(true);
      }
    }
  }
  render() {
    return (
      <div>
        <Helmet><title>登录</title></Helmet>
        <LoginNewCommon
          title=''
          btnTitle=''
          type={11}
          nextFunc={this.nextFunc}>
        </LoginNewCommon>
      </div>
    )
  }
}

LoginNew.propTypes = {
  saveUserInfo: PropTypes.func,
  userInfo: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveUserInfo: (userInfo) => dispatch(saveUserInfo(userInfo))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginNew);